import React from 'react';
import './settings.scss';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import ExportDataDTO from '../../../dto/ExportDataDTO';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import { VIOLATION_CODE_ENUM } from '../../../configs';
import MultipleSelectInput from '../../../components/fields/SelectInput/MultipleSelectInput';
import { Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { getSettingsData } from '../reducer';

export default function ExportDuploForm(props) {
  const {
    data, detection = false, cancel = () => {}, save = () => {},
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const DTO = new ExportDataDTO();
  const { violationList } = useSelector(getSettingsData);
  const attributes = DTO.getAttributesByName();
  const { control, getValues } = useForm({
    mode: 'onBlur',
    defaultValues: data,
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });

  const handleSave = () => {
    save(getValues());
  };

  const violationCodeOptions = violationList.map(v => ({ value: v.id, name: v.code_description }));
  return (
    <>
      <div className="settings-form">
        <div className="settings-view-form">
          <div className="export-form">
            <div className="f4 mb-3">DUPLO 2</div>
            {/* <FieldDTO */}
            {/*  control={control} */}
            {/*  component={TextInputWithLabel} */}
            {/*  dtoObject={attributes.uploader_name} */}
            {/*  variant="material" */}
            {/* /> */}
            {!detection ? (
              <FieldDTO
                control={control}
                component={MultipleSelectInput}
                dtoObject={attributes.violation_types}
                variant="material"
                className="mt-3"
                options={violationCodeOptions}
                withLabel
                multiple
              />
            ) : null}
            <FieldDTO
              control={control}
              component={TextInputWithLabel}
              dtoObject={attributes.uploader_url}
              variant="material"
              className="mt-3"
            />
            {/* <FieldDTO */}
            {/*  control={control} */}
            {/*  component={CheckBoxInputWithLabel} */}
            {/*  withLabel */}
            {/*  dtoObject={attributes.load_video} */}
            {/*  variant="material" */}
            {/*  className="mt-3" */}
            {/* /> */}
            <div className="hr-row mt-3" />
          </div>
        </div>
      </div>
      <div className="settings-footer">
        <Button className="clear-show" onClick={handleSave}>{formatMessage({ id: 'app.save' })}</Button>
        <Button
          className="clear-data"
          variant="secondary"
          onClick={cancel}
        >{formatMessage({ id: 'app.cancel' })}
        </Button>
      </div>
    </>
  );
}
